import React, { useState } from "react";
import { Box, TextField, Button, Typography, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Add } from "@mui/icons-material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  boxShadow: "none",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

const ProjectsForm = ({ onChildData }) => {
  const [projects, setProjects] = useState([
    {
      name: "",
      description: "",
      link: "",
    },
  ]);

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedProjects = [...projects];
    updatedProjects[index][name] = value;
    setProjects(updatedProjects);
    onChildData({ projects: updatedProjects });
  };

  const addProject = () => {
    setProjects([
      ...projects,
      {
        name: "",
        description: "",
        link: "",
      },
    ]);
  };

  const removeProject = (index) => {
    const updatedProjects = projects.filter((_, i) => i !== index);
    setProjects(updatedProjects);
    onChildData({ projects: updatedProjects });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const output = `projects:\n${projects
      .map(
        (proj) =>
          `  - name: "${proj.name}"\n    description: "${proj.description}"\n    link: "${proj.link}"`
      )
      .join("\n")}`;

    console.log(output);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 3,pt:0,pb:2 }}>
      <Typography variant="h4" sx={{ display: "none" }} gutterBottom>
        Projects
      </Typography>

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography variant="h6">Projects</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            {projects.map((project, index) => (
              <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
                <Grid size={12}>
                  <Item>
                    <TextField
                      fullWidth
                      label="Project Name"
                      name="name"
                      size="small"
                      placeholder="Weather App"
                      value={project.name}
                      onChange={(e) => handleChange(index, e)}
                      required
                    />
                  </Item>
                </Grid>
                <Grid size={12}>
                  <Item>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="A web application that provides real-time weather information using a third-party API."
                      label="Description"
                      name="description"
                      value={project.description}
                      onChange={(e) => handleChange(index, e)}
                      required
                    />
                  </Item>
                </Grid>
                <Grid size={10}>
                  <Item>
                    <TextField
                      fullWidth
                      label="Link"
                      name="link"
                      placeholder="https://github.com/janedoe/weather-app"
                      size="small"
                      value={project.link}
                      onChange={(e) => handleChange(index, e)}
                      required
                    />
                  </Item>
                </Grid>
                <Grid size={2}>
                  <Item>
                    <IconButton
                      onClick={() => removeProject(index)}
                      color="error"
                    >
                      <DeleteForeverIcon />
                    </IconButton>
                  </Item>
                </Grid>
              </Grid>
            ))}
            <Grid size={12}>
              <Item>
                <Button
                  variant="outlined"
                  onClick={addProject}
                  startIcon={<Add />}
                  sx={{ mb: 2 }}
                >
                  Add Project
                </Button>
              </Item>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Button type="submit" sx={{ display: "none" }} variant="contained">
        Submit
      </Button>
    </Box>
  );
};

export default ProjectsForm;
